import { Bean, BindingCreator } from '@dreryk/react-common';
import { DatePicker } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../translations';

type IdentityDocumentValidToFieldProps = {
   readonly name: string;
   readonly register: BindingCreator<Bean>;
   readonly testId?: string;
};

export const IdentityDocumentValidToField = (props: IdentityDocumentValidToFieldProps): JSX.Element => {
   return (
      <DatePicker
         testId={props.testId ?? 'identityDocumentValidTo'}
         controller={props.register(props.name)}
         defaultValue={null}
         dayValidators={'dayBeforeToday'}
         label={identityDocumentTranslationKeys.identityDocumentValidTo.label}
         placeholder={identityDocumentTranslationKeys.identityDocumentValidTo.placeholder}
         withNavigationArrows
         showClearButton
      />
   );
};
